import { Icon } from "@iconify/react";
import { usePatientAuthStore } from "@/stores/patientAuthStore";

function getInitials(name: string): string {
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p.charAt(0)).join("").toUpperCase();
}

export function CaregiverProfilePage() {
  const user = usePatientAuthStore((s) => s.user);

  return (
    <div className="mx-auto w-full max-w-[640px] px-8 py-8">
      <div className="rounded-3xl border border-[#E5E7EB] bg-white p-6 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#180047] text-lg font-bold !text-white">
            {user ? getInitials(user.name) : ""}
          </div>
          <div>
            <h1 className="text-lg font-extrabold text-[#0A2947]">{user?.name}</h1>
            <p className="text-sm text-[#6B7280]">{user?.email}</p>
          </div>
        </div>
        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-[#DBEAFE] bg-[#EFF6FF] p-4 text-xs leading-relaxed text-[#4B5563]">
          <Icon icon="lucide:info" className="mt-0.5 h-4 w-4 shrink-0 text-[#2563EB]" />
          <p>Editable profile settings for caregiver accounts aren't available yet — check back soon.</p>
        </div>
      </div>
    </div>
  );
}
